/**
 * Brand Utilities
 * Brand normalization and validation
 */

import { state } from '../core/state.js';

/**
 * Normalize brand name (case-insensitive lookup)
 * Only keeps brands that exist in facets (case-insensitive matching)
 * @param {string} brand
 * @returns {string|null}
 */
export function normalizeBrandName(brand) {
  if (!brand) return null;
  const brandLower = brand.toLowerCase().trim();
  if (!brandLower) return null;

  // Check in current facets first
  const facets = state.facets.brands || {};
  const facetKey = Object.keys(facets).find(
    (k) => k.toLowerCase() === brandLower
  );
  if (facetKey) return facetKey;

  // Check in allFacets if not found
  const allFacets = state.allFacets.brands || {};
  const allFacetKey = Object.keys(allFacets).find(
    (k) => k.toLowerCase() === brandLower
  );
  if (allFacetKey) return allFacetKey;

  // If not found in facets, return null (brand doesn't exist)
  return null;
}

/**
 * Normalize array of brand names
 * Only keeps brands that exist in facets (case-insensitive matching)
 * @param {string[]} brands
 * @returns {string[]}
 */
export function normalizeBrands(brands) {
  if (!Array.isArray(brands)) return [];
  return brands
    .map((b) => normalizeBrandName(b))
    .filter((b) => !!b) // Remove brands that don't exist in facets
    .filter((value, index, self) => {
      // Remove duplicates (case-insensitive)
      return (
        index ===
        self.findIndex((b) => b.toLowerCase() === value.toLowerCase())
      );
    });
}

console.log('📦 Brand utils module loaded');
